import { Cache } from "memory-cache";
import { CharacterBlueprintEntity } from ".";

// Cache
const cache = new Cache();
export async function getCachedCharacterBlueprintEntity(item_id: number): Promise<CharacterBlueprintEntity | null> {
  let entity: any = await cache.get(item_id.toString());
  if (entity) {
    return entity;
  }
  return null;
}
export function setCachedCharacterBlueprintEntity(characterBlueprint: CharacterBlueprintEntity) {
  cache.put(characterBlueprint.props.item_id.toString(), characterBlueprint, 60 * 60 * 1000 /* 1 hour */);
}
